import React from 'react';
import { useSelector } from 'react-redux';
import { GridInLoadingState } from '../../components/Grid/GridInLoadingState';
import { verticalActionTypesEnum, verticalTypesEnum } from '../../../../shared/src/enums/vertical-types.enum';
import { PreloadGamesGrid } from '../../components/Grid/PreloadGamesGrid';
import { CasinoGamesGrid } from '../../components/Grid/CasinoGamesGrid';
import { JackpotGamesGrid } from '../../components/Grid/JackpotGamesGrid';
import { RecommendationGamesGrid } from '../../components/Grid/RecommendationGamesGrid';
import { GridPageContent } from '../../components/GridPage/GridPageContent';
import { subcategoryTypesEnum } from '../../../../shared/src/enums/subcategory-types';

/**
 * Depending on page loading state - shows games grid in relevant state
 * E.g. platform loading state and preload games readiness
 */
export const GridContent = ({
    vertical,
    currentSubcategory,
    showWinnersLoader,
    gridContentLoaded = false,
    categories = [],
    setCurrentSubcategoryId,
}) => {
    const { prioritizedGames } = useSelector((state) => state.casino);

    if (currentSubcategory.type === subcategoryTypesEnum.GRID_PAGE) {
        return <GridPageContent
            gridPage={currentSubcategory.gridPage}
            categories={categories}
            setCurrentSubcategoryId={setCurrentSubcategoryId}
        />;
    }

    // choose relevant grid component
    let gridContent = <GridInLoadingState showWinnersLoader={showWinnersLoader} />;

    // preloaded games will be shown even if platform games are not available yet
    const preloadedGamesForVertical = prioritizedGames?.[vertical.type];
    if (
        !gridContentLoaded
        && currentSubcategory.action === verticalActionTypesEnum.FEATURED_GAMES
        && preloadedGamesForVertical
    ) {
        gridContent = <PreloadGamesGrid preloadedGames={preloadedGamesForVertical} />;
    }

    // if loaded - show real grid
    if (gridContentLoaded) {
        const gridComponentsByType = {
            [verticalTypesEnum.CASINO]: {
                GridComponentByType: CasinoGamesGrid,
                props: () => ({
                    gameIds: currentSubcategory.gameIds,
                    showWinners: showWinnersLoader,
                    currentSubcategoryAction: currentSubcategory.action,
                }),
            },
            [verticalTypesEnum.LIVE_CASINO]: {
                GridComponentByType: CasinoGamesGrid,
                props: () => ({
                    gameIds: currentSubcategory.gameIds,
                    showWinners: showWinnersLoader,
                    currentSubcategoryAction: currentSubcategory.action,
                }),
            },
            [verticalTypesEnum.JACKPOT]: {
                GridComponentByType: JackpotGamesGrid,
                props: () => ({
                    gameIds: currentSubcategory.content?.games || [],
                    jackpots: currentSubcategory.content?.jackpots || [],
                }),
            },
            [verticalTypesEnum.RECOMMENDATIONS]: {
                GridComponentByType: RecommendationGamesGrid,
                props: () => ({
                    gamesByCategories: currentSubcategory.content?.gamesByCategories
                }),
            },
        };

        const { GridComponentByType, props } = gridComponentsByType[vertical.type];

        gridContent = <GridComponentByType {...props()} />;
    }

    return <>{ gridContent }</>;
};
